module.exports = __webpack_public_path__ + "html/project-summary_441f595237bb1a3c850834bc1605c003.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/project/project-summary.html
// module id = O3cu
// module chunks = 154